import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;

  > h1 {
    text-align: center;
  }
`;

export const WrapperButton = styled.div`
  margin-bottom: 24px;
`;

export const Table = styled.div`
  margin-bottom: 32px;

  > div + div {
    margin-top: 16px;
  }

  > div:nth-child(odd) {
    background: #e8e8e8;
  }

  > div:nth-child(even) {
    background: #f7f7f7;
  }
`;

export const TableItem = styled.div`
  border-radius: 10px;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  grid-template-areas: "nome eye" "status status";

  > :nth-child(1) {
    grid-area: nome;
  }

  > :nth-child(2) {
    grid-area: status;
  }

  > :nth-child(3) {
    grid-area: eye;
  }

  > p {
    color: var(--PADO-1, #2d2d2d);
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    span {
      font-weight: 400;

      &.ativo {
        font-weight: 700;
        color: #558fff;
      }
      &.inativo {
        font-weight: 700;
        color: #ed0000;
      }
    }
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 0.1fr;
    grid-template-areas: "nome status eye";
    align-items: center;
  }
`;
